// Session query ranges shared by the portal pages and the offline prefetch, so both build the same query keys.
import { addDays, addWeeks, endOfWeek, format, startOfWeek } from 'date-fns';

/** Coach portal: sessions from yesterday onwards (no upper bound). */
export function getCoachPortalSessionsFrom(now: Date = new Date()): string {
  return format(addDays(now, -1), 'yyyy-MM-dd');
}

/** Student portal: from the start of the current week to the end of the week four weeks ahead. */
export function getStudentPortalSessionRange(now: Date = new Date()): { from: string; to: string } {
  const weekStart = startOfWeek(now, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(addWeeks(now, 4), { weekStartsOn: 1 });
  return { from: format(weekStart, 'yyyy-MM-dd'), to: format(weekEnd, 'yyyy-MM-dd') };
}
